import { render, staticRenderFns } from "./PurchasesDetailUpdate.vue?vue&type=template&id=f3664ace"
import script from "./PurchasesDetailUpdate.vue?vue&type=script&lang=js"
export * from "./PurchasesDetailUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports